import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EnumItem } from '@core/models/enum-item.model';
import { BudgetTypeEnum } from '@enums/BudgetType';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { EstimateBudgetTypes } from '../models/estimate-budget-types.model';
import { EstimateBudgetTypesEnum } from '../models/estimate-buget-types.enum';

@Component({
  selector: 'pop-estimate-budget-type',
  templateUrl: './estimate-budget-type.component.html',
  styleUrls: ['./estimate-budget-type.component.less']
})
export class EstimateBudgetTypeComponent {
  @Input() public estimateBudgetType = EstimateBudgetTypesEnum.Global;

  private _estimateBudgetTypes: EstimateBudgetTypes;
  @Input() public get estimateBudgetTypes() {
    return this._estimateBudgetTypes;
  }
  public set estimateBudgetTypes(value: EstimateBudgetTypes) {
    this._estimateBudgetTypes = value;
    this.estimateBudgetTypesChange.emit(value);
  }

  @Output() public estimateBudgetTypesChange = new EventEmitter<EstimateBudgetTypes>();

  public get selectedType() {
    return this.estimateBudgetTypes?.get(this.estimateBudgetType) ?? BudgetTypeEnum.Summary;
  }
  public set selectedType(value: BudgetTypeEnum) {
    this.estimateBudgetTypes.set(this.estimateBudgetType, value);
    this.estimateBudgetTypesChange.emit(this.estimateBudgetTypes);
  }

  private _consentGranted: boolean;
  @Input() public get consentGranted() {
    return this._consentGranted;
  }
  public set consentGranted(value: boolean) {
    this._consentGranted = value;
    this.consentGrantedChange.emit(value);
  }

  @Output() public consentGrantedChange = new EventEmitter<boolean>();

  @Input()
  public disabled = false;

  public get labelKey() {
    return `BUDGET_TYPE_COMPONENT.LABEL_${this.estimateBudgetType.toLocaleUpperCase()}`;
  }

  public get headerKey() {
    return `BUDGET_TYPE_COMPONENT.HEADER_${this.estimateBudgetType.toLocaleUpperCase()}`;
  }

  public constructor(
    private confirmationService: ConfirmationService,
    private translateService: TranslateService
  ) {}

  public click(event: MouseEvent) {
    if (this.consentGranted) {
      return; // do nothing
    }
    event.preventDefault();

    this.confirmationService.confirm({
      closeOnEscape: true,
      dismissableMask: true,
      message: this.translateService.instant('ERROR.BUDGET') as string,
      header: this.translateService.instant(this.headerKey) as string,
      icon: 'fas fa-exclamation-triangle',
      key: 'global-confirmation-dialog',
      acceptLabel: this.translateService.instant('BUTTON.CONFIRM') as string,
      rejectLabel: this.translateService.instant('BUTTON.CANCEL') as string,
      accept: () => {
        this.consentGranted = true;
        this.toggle();
      }
    });
  }

  public toggle() {
    if (this.selectedType === BudgetTypeEnum.Summary) {
      this.selectedType = BudgetTypeEnum.Detailed;
      return;
    }
    this.selectedType = BudgetTypeEnum.Summary;
  }

  public budgetTypes: EnumItem<BudgetTypeEnum>[] = [
    {
      key: BudgetTypeEnum.Summary,
      titleKey: 'BUDGET_TYPE.' + BudgetTypeEnum.Summary.toUpperCase()
    },
    {
      key: BudgetTypeEnum.Detailed,
      titleKey: 'BUDGET_TYPE.' + BudgetTypeEnum.Detailed.toUpperCase()
    }
  ];
}
